import React, { useState } from "react";
import styled from "styled-components";

const RADIUS = 40;
const RIGHT_POS = "2rem";

const StyledHelp = styled.div`
  width: ${RADIUS}px;
  height: ${RADIUS}px;
  position: fixed;
  line-height: ${RADIUS}px;
  top: calc(100vh - 50px);
  right: ${RIGHT_POS};
  background: ${props => props.theme.colors.gray2};
  border: 2px solid ${props => props.theme.colors.gray1};
  border-radius: 100%;
  text-align: center;
  cursor: pointer;
  user-select: none;
  font-size: 0.9rem;

  .help-info {
    text-align: left;
    position: absolute;
    width: 240px;
    bottom: ${RADIUS + 10}px;
    right: 0;
    padding: 0.75rem;
    background: ${props => props.theme.colors.gray2};
    border: 2px solid ${props => props.theme.colors.gray1};
    border-radius: 4px;

    li {
      margin-bottom: 0.5rem;
    }
  }
`;

interface Props {
  rows: string[];
}

const Help: React.FC<Props> = ({ rows }) => {
  const [isOpen, setOpen] = useState(false);

  const onClick = () => {
    setOpen(!isOpen);
  };

  return (
    <StyledHelp onClick={onClick}>
      ?
      {isOpen && (
        <div className="help-info">
          <ul>
            {rows.sort().map((row, i) => (
              <li key={i}>{row}</li>
            ))}
          </ul>
        </div>
      )}
    </StyledHelp>
  );
};

export default Help;
